import { render, staticRenderFns } from "./ConfigOthers.vue?vue&type=template&id=418c4828&lang=pug&"
import script from "./ConfigOthers.vue?vue&type=script&lang=js&"
export * from "./ConfigOthers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports